<template>
  <div style="height: 60px;background:#fff;">
    <div class="comHeader">
      <span class="name">{{name}}</span>
      <div class="userContent">
        <router-link v-if="!getters.user" :to="{ name: 'login' }">
          <span>登录</span>
        </router-link>
        <el-dropdown v-if="!getters.user" style="margin-left:20px;">
          <span class="el-dropdown-link" style="color:#1890ff;">
            注册
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item style="padding:0 20px;">
              <router-link :to="{ name: 'registerComUser' }">成员注册</router-link>
            </el-dropdown-item>
            <el-dropdown-item style="padding:0 20px;">
              <router-link :to="{ name: 'registerUser' }">用户注册</router-link>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <a v-if="getters.user" @click="loginOut">退出</a>
      </div>

      <el-menu
        :default-active="activeIndex"
        class="el-menu-header"
        mode="horizontal"
        @select="handleSelect"
      >
        <template v-for="item in list">
          <el-menu-item
            @click="jump(item)"
            class="el-menu-item"
            :index="item.id"
            v-if="item.children.length==0"
            :key="item.id"
          >{{item.itemText}}</el-menu-item>
          <el-submenu :index="item.id" v-else :key="item.id">
            <template slot="title">{{item.itemText}}</template>
            <el-menu-item
              @click="jump(i)"
              :index="i.id"
              v-for="(i,index) in item.children"
              :key="index"
            >{{i.itemText}}</el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { menuItem_qy, login } from "@/api/home";
import router from "@/router/index";
const getCookie = name => {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  return (arr = document.cookie.match(reg)) ? unescape(arr[2]) : null;
};
const delCookie = name => {
  var exp = new Date();
  exp.setTime(exp.getTime() - 60 * 60 * 1000 * 24);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie =
      name + "=" + cval + ";expires=" + exp.toGMTString() + ";path=/";
};
export default {
  data() {
    return {
      activeIndex: "0",
      name: "重庆三峡库区医教协同职业教育集团",
      list: [],
      getters: {}
    };
  },
  mounted() {
    router.beforeEach((to, from, next) => {
      console.log(to);
      console.log(from);
      console.log(next);
      next();
      setTimeout(() => {
        if (to.query && to.query.id) {
          this.activeIndex = to.query.id;
        } else {
          this.activeIndex = this.$route.query.id;
        }
      }, 100);
    });
  },
  created() {
    this.getters = this.$store.getters;

    this.list = this.$store.getters.menu;
    this.activeIndex = this.$route.query.id || this.list[0].id + "";
  },
  components: {},
  methods: {
    loginOut() {
      this.$confirm("确定退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          login({ op: "login", doLogin: 0 }).then(res => {
            delCookie("password");
            delCookie("organFlag");
            delCookie("userCode");
            delCookie("loginType");
            this.$message({
              showClose: true,
              message: "退出成功"
            });
            window.location.reload();
            //this.$store.dispatch("getUser", {});
          });
        })
        .catch(() => {});
    },
    handleSelect() {},
    jump(item) {
      if (item.id == this.activeIndex) {
        return;
      }
      this.activeIndex = item.id;
      this.$forceUpdate();
      if (item.pageUrl && item.pageUrl != "-") {
        if (item.pageUrl == "/leftMenuListPage") {
          this.$router.push({
            path: item.pageUrl,
            query: {
              id: item.id,
              url: item.argumentsText
            }
          });
        } else if (item.pageUrl == "/parallelListPage") {
          this.$router.push({
            path: item.pageUrl,
            query: {
              id: item.id,
              url: item.argumentsText
            }
          });
        } else if (item.pageUrl.indexOf("www.") == 0) {
          window.open("http://" + item.pageUrl);
        } else if (item.pageUrl.indexOf("http") == 0) {
          window.open(item.pageUrl);
        } else {
          this.$router.push({
            path: item.pageUrl,
            query: {
              id: item.id
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped lang="less">
.comHeader {
  width: 1200px;
  margin: 0 auto;
  height: 60px;
  background: #fff;
  .name {
    line-height: 60px;
    font-size: 24px;
    font-weight: 600;
    color: #666;
  }
  .userContent {
    float: right;
    line-height: 60px;
    font-size: 14px;
    a {
      margin-left: 30px;
    }
  }
  .el-menu-header {
    vertical-align: middle;
    border: none;
    float: right;
    padding: 0 10px;

    /deep/.is-active {
      background: #1890ff !important;
      color: #fff !important;
      .el-submenu__title {
        background: #1890ff !important;
        color: #fff !important;
        .el-icon-arrow-down {
          color: #fff !important;
        }
      }
    }
    // /deep/.is-opened {
    //   .el-submenu__title:hover {
    //     background: #dbf4fe;
    //   }
    // }
    .el-menu-item:hover {
      background: #dbf4fe;
    }
    /deep/.el-submenu:hover {
      background: #dbf4fe;
      .el-submenu__title {
        background: #dbf4fe;
      }
    }
    .el-menu-item {
      padding: 0 10px;
    }
  }
  /deep/.el-submenu__title {
    padding: 0 10px;
  }
}
</style>